module.exports = __webpack_public_path__ + "media/src/admin/images/js-grid-183e26a4b6c36cbf860fdce527512b7b.png";